<template>
<div class="maintainPage">
  <head-guide></head-guide>
  <aside-menu></aside-menu>
  <div class="commonPage" :style="{height:pageHeight + 'px',width:pageWidth + 'px'}">
    <vue-scroll class="content">
      <tabs></tabs>
    </vue-scroll>
  </div>
</div>
</template>

<script>
import tabs from '../../components/tabs'
export default {
  data(){
    return {
      pageHeight:window.innerHeight - 88,
      pageWidth:window.innerWidth - 200
    }
  },
  mounted(){
    let _this = this;
    window.onresize = function(){
      _this.pageHeight = window.innerHeight - 88;
      _this.pageWidth = window.innerWidth - 200;
    }
  },
  components:{
    tabs
  }
}
</script>

<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/components/basics/generalContainer.vue